import React from 'react'
import { NavLink } from 'react-router-dom'

const Kyc2 = () => {
  return (
    <div>
        <div className='container' style={{height:'99vh'}}>
            <div className='row'>
                <div className='col-lg-12 col-sm-12  mt-5 pt-5'> 
                    <p style={{color:'#959595'}}>You need to submit a document that shows that you are above 18 years of age and not a resident of <strong> Assam, Odisha, Sikkim, Nagaland, Telangana, Andhra Pradesh, Tamil Nadu and Karnataka.</strong>
                    For manual <NavLink to="/ky3"  style={{textDecoration:'none'}}> KYC Click here </NavLink></p>



<p style={{color:'#959595'}}>Enter details of Aadhar Card:</p>


<div class="mb-3 mt-4">
    <label for="exampleInputEmail1" class="form-label">Aadhar Number</label>
    <input type="number" class="form-control py-2" id="exampleInputEmail1" aria-describedby="emailHelp"  placeholder='AADHAR  NUMBER'  style={{boxShadow:'none', border:'1px solid #ffcc5b'}}/> 
  </div>

<div class="mb-3">
    <label for="exampleInputEmail1" class="form-label">Email</label>
    <input type="text" class="form-control py-2" id="exampleInputEmail1" aria-describedby="emailHelp"  placeholder='EMAIL'  style={{boxShadow:'none', border:'1px solid #ffcc5b'}}/> 
  </div>

  <div>
    <button className='btn w-100 py-2 mt-4' style={{backgroundColor:'#00d25b', color:'#fff',}}>SEND OTP</button>
  </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Kyc2